module.exports = __webpack_public_path__ + "img/fontawesome-webfont.acf3dcb7.svg";